import React, { useState, useEffect } from "react";
import apiCalls from "shared/utils/apiCalls";
import Feedback from "shared/components/Feedbacks/Feedback/Feedback";
import { Link } from "react-router-dom";
import styles from "./FeedbacksFeed.module.scss";
import moment from "moment";
import Skeleton from "@material-ui/lab/Skeleton";

const FeedbacksFeed = () => {
  const [feedbacks, setFeedbacks] = useState<any>([]);
  const getRecentFeedbacks = async () => {
    const res = await apiCalls({
      method: "get",
      url: `/feedbacks`,
    });

    if (res) {
      setFeedbacks(res.data);
    }
  };

  useEffect(() => {
    getRecentFeedbacks();
  }, []);

  return (
    <div className={styles.feedbacksFeed}>
      <h1>Feedback</h1>
      {feedbacks && feedbacks.length > 0 ? (
        feedbacks.map((feedback: any) => (
          <div className={styles.feedbacksFeed_card} key={feedback.id}>
            <div className={styles.feedbacksFeed_card_time}>
              {moment(feedback.submittedAt).toNow()}
            </div>

            <Link
              to={`/solutions/${feedback?.parentId}`}
              className={styles.feedbacksFeed_card_title}
            >
              {feedback?.solution?.title}
            </Link>

            <Feedback
              key={feedback.id}
              feedback={feedback}
              getFeedbacks={getRecentFeedbacks}
              showReplies={false}
            />
          </div>
        ))
      ) : (
        <div>
          {[0, 1, 2, 3, 4, 5, 6, 7].map((number) => (
            <div style={{ marginBottom: "var(--space-xl)" }} key={number}>
              <Skeleton key={number} height={220} variant="rect" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FeedbacksFeed;
